/**
 * Элемент вкладки для VTabsV2.
 *
 * Универсальный, ничего не знает про заказы/роли/права — это просто
 * данные одной вкладки. Списки TabElement[] собирают сервисы доменов
 * (например OrdersService), накладывая туда свою специфику.
 */
class TabElement {

	/** id вкладки — подставляется в url как `${baseUrl}/${id}` */
	public id: string;

	/** Название вкладки */
	public name: string;

	/**
	 * Счётчик. null = счётчика нет, скобки не рисуются.
	 * Число (в т.ч. 0) = рисуется `(count)`.
	 */
	public count: number | null;

	/** true = вкладка прячется в выпадашку «ещё» */
	public hidden: boolean;

  /**
   * Цвет вкладки — произвольная индикация от домена (стадия, статус).
   * null = цвета нет, вкладка красится дефолтом из VTabsV2.scss.
   * Значение уходит в CSS-переменную --active-color активной вкладки.
   */
  public color: string | null;

	static from(
    id: string,
    name: string,
    count: number | null = null,
    hidden: boolean = false,
    color: string | null = null
  ): TabElement {
		const tab = new this();

		tab.id     = id;
		tab.name   = name;
		tab.count  = count;
		tab.hidden = hidden;
    tab.color  = color;

		return tab;
	}

	/**
	 * Имя для отображения: имя + счётчик в скобках, если счётчик задан.
	 * Здесь живёт склейка «В работе (710)» — данные (name/count) хранятся
	 * раздельно, представление собирается в одном месте.
	 */
	public get displayName(): string {
		if (this.count === null) {
			return this.name;
		}
		else {
			return `${this.name} (${this.count})`;
		}
	}
}

export default TabElement;
